<style scoped>
  /*.article-detail {*/
  /*  position: absolute;*/
  /*  top: 0;*/
  /*  right: 0;*/
  /*  left: 0;*/
  /*  bottom: 0;*/
  /*}*/
  .article-detail {
    background: #F2F2F2;
  }
  .f-article {
    border-bottom: 1px solid #e6e6e6;
    margin: 0 0 .375rem 0;
    background: #ffffff;
    padding-left: .9375rem;
    padding-right: .9375rem;
  }
  .text-cut {
    color: #858585;
  }
  .article-wrap {
    font-size: 1rem;
    line-height: 1.6;
  }
  .icon-img {
    width: 1rem;
    height: 1rem;
  }
  .info-wrap {
    font-size: 1rem;
    display: flex;
    padding-bottom: 1.25rem;
    justify-content: space-between;
  }
  .read,.like,.comment {
    margin-top: .4rem;
    padding: .3125rem .625rem .3125rem .3125rem;
  }
  .font-num span {
    color: #adadad;
  }
  .lite-page-tab {
    position: relative;
    font-size: .875rem;
    background: white;
    height: 2.5rem;
    line-height: 2.5rem;
    padding: 0 .75rem;
    box-shadow: 0 1px 0 0 #e6e6e6;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
  }
  .card-wrap {
    margin: 0 .75rem;
  }
  .card-main {
    padding: .75rem 0;
  }
  .m-box {
    display: flex;
    font-size: 1rem;
  }
  .m-img-box {
    width: 2rem;
    height: 2rem;
    position: relative;
    margin: 0 .5rem 0 0;
  }
  .m-img-box:before {
    content: '';
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* border: 1px solid rgba(0, 0, 0, .05); */
  }
  .m-img-box img {
    width: 100%;
    height: 100%;
  }
  .m-box-col {
    flex: 1;
    width: 100%;
    min-width: 0;
  }
  .m-box-center {
    display: flex;
    justify-content: center;
  }
  .m-box-dir {
    flex-direction: column;
  }
  .m-text-cut {
    color: #333333;
    font-size: .875rem;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .m-text-box>* {
    margin: 0 0 .375rem 0;
  }
  .m-text-box h3 {
    font-size: 1rem;
    line-height: 1.4;
    color: #333333;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .cmt-sub-txt {
    line-height: 1.25rem;
    padding: .5rem .625rem;
    background: #f7f7f7;
    color: #333333;
    font-size: .875rem;
    word-wrap: break-word;
  }
  .cmt-sub-txt p {
    margin: 0;
  }
  .cmt-sub-txt .cmt-sub-username {
    color: #6c7880;
    font-size: .875rem;
    word-break: keep-all;
  }
  .cmt-sub-txt span {
    color: #333333;
    font-size: .875rem;
  }
  .cmt-sub-txt .cmt-sub-content {
    word-break: break-all;
  }
  .cmt-sub-txt .total {
    color: #507DAF;
    cursor: pointer;
  }
  .lite-bot {
    margin-top: .5rem;
    line-height: .9375rem;
    font-size: .875rem;
    color: #999;
  }
  .m-box-center-a {
    display: flex;
    align-items: center;
  }
  .lite-bot .time {
    float: left;
  }
  .lite-bot aside {
    float: right;
  }
  .lite-bot aside em {
    margin-left: .1875rem;
    font-style: normal;
  }
  .lite-bot aside+aside {
    margin-right: .875rem;
  }
  .lite-line {
    border-top-width: 1px;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-style: solid;
    border-color: #eee;
    margin: -.75rem -.75rem 0 0;
    padding: .75rem .75rem 0 0;
  }
  #comment_0 {
    border-top-width: 0;
    border-color: #fff;
  }
  .lite-page-editor {
    position: fixed;
    overflow: hidden;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 2.75rem;
    background: #1C74FF;
    color: #333;
    z-index: 995;
    border-top-width: 1px;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-color: hsla(0,0%,68.6%,.5);
    border-style: solid;
    /*transform: translateZ(0);*/
    /*-webkit-transform: translateZ(0);*/
    /*height: 3.125rem;*/
    /*width: 100%;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*background: #ffffff;*/
    /*z-index: 995;*/
  }
  .lite-page-editor .box-left {
    font-size: 0;
    min-width: 0;
    margin-left: .75rem;
    height: 3.125rem;
    line-height: 3.125rem;
  }
  .lite-page-editor .box-left .main-text {
    font-size: 1rem;
    min-width: 0;
    display: block;
    max-width: 100vw;
  }
  .lite-page-editor .box-left .focus {
    color: #a5adb5;
  }
  .lite-page-editor .box-right {
    margin-right: .75rem;
  }
  .rubberBand {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-name: rubberBand;
    animation-name: rubberBand;
  }
  .refresh-rotate {
    animation: rotate .5s linear infinite;
    -webkit-animation: rotate .5s linear infinite;
  }
  .m-wpop-box {
    background-color: rgba(0, 0, 0, .5);
    top: 0;
    z-index: 10000;
  }
  .m-wpop-box,.m-wpbtn-lbox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

  }
  .m-wpbtn-lbox {
    z-index: 10001;
    background: #dee3de;
  }
  .m-wpbtn-list {
    background: #fff;
    display: block;
  }
  .m-wpbtn-list li {
    width: 100%;
    display: block;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
  }
  .m-wpbtn-list li a {
    font-size: 1.125rem;
    color: #333;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;
  }
  .m-wpbtn-list+.m-wpbtn-list {
    margin-top: .3125rem;
  }
  .link-blue {
    color: #1897f2;
    cursor: pointer;
  }
  @keyframes rubberBand {
    from {
      transform: scale3d(1, 1, 1);
    }
    30% {
      transform: scale3d(1.25, 0.75, 1);
    }
    40% {
      transform: scale3d(0.75, 1.25, 1);
    }
    50% {
      transform: scale3d(1.15, 0.85, 1);
    }
    65% {
      transform: scale3d(.95, 1.05, 1);
    }
    75% {
      transform: scale3d(1.05, .95, 1);
    }
    to {
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
    }
  }
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    /* transition: all .3s ease; */
    transition: all .3s linear;
  }
  .slide-fade-leave-active {
    /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
    transition: all .8s linear;
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(10px);
    opacity: 0;
  }
  .comment-content {
    padding-bottom: 3.44rem;
    background-color: #f2f2f2;
    position: relative;
    min-height: 15rem;
  }
  .empty {
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 102px 0 20px;
    font-size: .875rem;
    color: #929292;
    text-align: center;
  }
  .empty-block {
    background: #fbfbfb;
  }
  .no-write-comment-content {
    padding-bottom: 0;
  }
  @media only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:3){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  @media only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:2){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  @media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:2){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  @media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
</style>

<template>
  <div class="article-detail m-container-max">
    <div class="lite-page-editor" :style="{left: bottomLeft}" v-if="isMideaConnect">
      <div class="m-box" style="display: flex;justify-content: center;align-items: center;height: 2.75rem;" @click="writeComment('1', articleId)">
<!--        <div class="box-left m-box-col m-box-center-a" style="flex-basis: 80%;" @click="writeComment('1', articleId)">-->
<!--          <span class="m-box-center-a main-text m-text-cut focus">发表评论</span>-->
<!--        </div>-->
<!--        <div class="box-right m-box-col m-box-center-a" style="justify-content: center;" @click.stop="thinkGood(articleDetail, 'article')">-->
<!--          <img class="rubberBand" src="../assets/images/good-blue.png" v-if="articleDetail.hasClicked" style="width: 1.25rem; height: 1.25rem;" alt=""/>-->
<!--          <img v-else src="../assets/images/good-gray.png"  alt="" style="width: 1.25rem; height: 1.25rem;" />-->
<!--        </div>-->
        <span style="color: #fff;">{{$t('lang.writeComment2')}}</span>
      </div>
    </div>
    <div class="main">
      <div class="card">
        <ArticleTemplate :article-detail="articleDetail"
                         @good="myThinkGood"></ArticleTemplate>
        <div @touchmove="loadComment()" @mousewheel="loadComment()">
          <div class="lite-page-tab">
            <span style="line-height: 1.25rem;margin-right: .375rem;padding-top: .125rem;">{{$t('lang.comment')}}</span>
            <img src="../assets/images/refresh.png" alt="" style="width: 1.25rem;height: 1.25rem;" @click="refresh()" :class="{'refresh-rotate': isRefresh}">
          </div>
          <div class="comment-content" :class="{'empty-block': appCommentList.length === 0, 'no-write-comment-content': !isMideaConnect}">
            <div style="background: #ffffff;" v-for="(item, index) in appCommentList" :key="'info2-'+item.id+index">
              <div class="card-avatar-box">
                <div class="card-wrap">
                  <div class="card-main">
                    <div class="m-box">
                      <div class="m-img-box">
                        <img src="../assets/images/photo_default_icon.png" alt="" v-if="item.hideName === 1">
                        <img :src="commentHeadImgUrl+item.createUserAccount" :onerror="defaultHead" alt="" style="border-radius: 50%;" v-else>
                      </div>
                      <div class="m-box-right m-box-col m-box-center m-box-dir lite-line" :id="'comment_'+index">
                        <div class="m-box">
                          <div class="m-box-dir m-box-col">
                            <div class="m-text-box" @click="transShow(item.id)">
                              <h4 class="m-text-cut">{{item.createUsername}}</h4>
                              <div v-if="!item.contentTooLong">
                                <h3>{{item.content}}<a class="link-blue" v-show="item.content.length > 92" href="javascript:void(0);" style="float: right;padding-right: .5rem;" @click.stop="item.contentTooLong = !item.contentTooLong">{{$t('lang.hide')}}</a></h3>
                              </div>
                              <div v-else>
                                <h3>{{item.content.substring(0, 92) + '...'}}<a class="link-blue" href="javascript:void(0);" style="float: right;padding-right: .5rem;" @click.stop="item.contentTooLong = !item.contentTooLong">{{$t('lang.all')}}</a></h3>
                              </div>
                              <div style="clear: both;"></div>
                              <div class="cmt-sub-txt" v-if="item.subReplayList.length > 0">
                                <div v-for="comment in item.subReplayList" :key="comment.id" v-show="!comment.hidden">
                                  <p>
                                    <a href="javascript:void(0);" class="cmt-sub-username">{{comment.createUsername}}</a>
                                    <span>:</span>
                                    <span v-if="!comment.contentTooLong" class="cmt-sub-content">{{comment.content}}<a v-show="comment.content.length > 72" class="link-blue" style="float: right;padding-right: .5rem;" href="javascript:void(0);" @click.stop="comment.contentTooLong = !comment.contentTooLong">{{$t('lang.hide')}}</a></span>
                                    <span v-else class="cmt-sub-content">{{comment.content.substring(0, 72) + '...'}}<a class="link-blue" style="float: right;padding-right: .5rem;" href="javascript:void(0);" @click.stop="comment.contentTooLong = !comment.contentTooLong">{{$t('lang.all')}}</a></span>
                                  </p>
                                  <div style="clear: both;"></div>
                                </div>
                                <p>
                                <span class="total link-blue" @click.stop="displaySubReply($event, item.subReplayList)" style="color: #1897f2;" v-if="item.subReplayList.length > 3">
                                  {{$t('lang.seeAll')}}{{item.subReplayList.length}}{{$t('lang.replies')}}
                                </span>
                                </p>
                              </div>
                            </div>
                            <div class="lite-bot m-text-cut">
                              <div class="m-box-center-a time">{{item.createTime | showWeekday}}</div>
                              <aside @click="writeComment('2', item.id)">
                                <img src="../assets/images/comment.png" style="width: .875rem;height: .875rem;margin-top: .125rem;" alt="">
                                <em></em>
                              </aside>
                              <aside @click="thinkGood(item, 'comment')">
                                <img src="../assets/images/good-blue.png" v-if="item.hasClicked" style="width: .875rem;height: .875rem;margin-right: .25rem;" alt="" class="rubberBand">
                                <img src="../assets/images/good-gray.png" v-else style="width: .875rem;height: .875rem;margin-right: .25rem;" alt="">
                                <em>{{item.likedNum || 0}}</em>
                              </aside>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty" v-if="appCommentList.length === 0">{{$t('lang.writeAComment')}}</div>
            <!--<p style="font-size: .875rem;text-align: center;color: gray;padding-top: .25rem;">--已无更多数据--</p>-->
          </div>
        </div>
      </div>
    </div>

    <div class="m-wpop-box" v-show="show">
    <!--<div class="m-wpop-box" v-show="show" @click.stop.prevent = transShowClose>-->
<!--        <div class="m-wpbtn-lbox" v-if="show">-->
<!--          <ul class="m-wpbtn-list" @click="writeComment('2')">-->
<!--            <li>-->
<!--              <a href="javascript:void(0);">回复</a>-->
<!--            </li>-->
<!--          </ul>-->
<!--          <ul class="m-wpbtn-list" @click="transShow('')">-->
<!--            <li>-->
<!--              <a href="javascript:void(0);">取消</a>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
    </div>
    <reply-Popup
      ref='replyPopup'
      :show="show"
      @close="transShowClose"
      :commentParams="commentParams"
      :headImgUrl="headImgUrl"
    ></reply-Popup>
    <div style="position: fixed;top: 0;left: 0;bottom: 0;right: 0;background-color: rgba(0,0,0,.5);z-index: 10002;" v-if="errorStatus"></div>
  </div>
</template>

<script>
import { isPC, Throttle, isMideaConnect, getCookie, getCookieOfToken } from '../utils/utils'
import Vue from 'vue'
import { articleMixin } from '../mixins/article'
import ArticleTemplate from '../components/ArticleTemplate'
import replyPopup from '../components/replyPopup'
export default {
  components: {
    ArticleTemplate,
    replyPopup
  },
  data () {
    return {
      success: null,
      articleDetail: { title: '', createDataTime: '', author: '' },
      bottomLeft: '0',
      appCommentList: [],
      isRefresh: false,
      show: false,
      loadingMoreStatus: 0, // 0 未开始 1 正在加载 2 已结束
      pageNum: 1,
      commentId: '',
      hasLoadComment: false,
      showPopup: false,
      commentParams: {},
      headImgUrl: '',
      defaultHead: 'this.src="' + require('../assets/images/photo_default.png') + '"'
    }
  },
  mixins: [articleMixin],
  computed: {
    isPC () {
      return isPC()
    },
    isMideaConnect () {
      // return true
      return isMideaConnect()
    }
  },
  methods: {
    weixinShare () {
      const self = this
      if (window.isWxTagLaunch) {
        window.wx.ready(function () {
          window.wx.onMenuShareAppMessage({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            desc: self.articleDetail.summary,
            success: function () {
              console.log('share app message success!!!')
            }
          })
          window.wx.onMenuShareTimeline({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            success: function () {
              console.log('share timeline success!!!')
            }
          })
        })
      }
    },
    myThinkGood (val) {
      this.thinkGood(val.item, val.typeStr)
    },
    transShow (clickId) {
      if (!this.isMideaConnect) {
        return
      }
      this.commentId = clickId
      this.commentParams = { id: this.commentId, targetType: '2', type: this.$route.query.type || '' }
      this.show = !this.show
    },
    transShowClose () {
      this.show = false
    },
    refresh () {
      this.isRefresh = true
      this.getCommentDetail()
    },
    displaySubReply (e, comment) {
      if (comment[3].hidden) {
        e.target.innerHTML = this.$t('lang.hide')
      } else {
        e.target.innerHTML = `${this.$t('lang.seeAll')}${comment.length}${this.$t('lang.replies')}`
      }
      for (let i = 3; i < comment.length; i++) {
        comment[i].hidden = !comment[i].hidden
      }
    },
    writeComment (targetType, id = null) {
      if (!this.isMideaConnect) {
        return
      }
      if (id === null) {
        if (targetType === '1') {
          id = this.articleId
        } else {
          id = this.commentId
        }
      }
      console.log('容器高度为:' + (document.documentElement.scrollHeight || document.body.scrollHeight))
      console.log('滚动高度为:' + (document.documentElement.scrollTop || document.body.scrollTop))
      // this.appCommentList = []
      this.hasLoadComment = false
      // this.$router.push({ path: '/writeComment', query: { id: id, targetType: targetType, type: this.$route.query.type || '' } })
      this.commentParams = { id: id, targetType: targetType, type: this.$route.query.type || '' }
      this.show = true
    },
    thinkGood (item, typeStr) {
      const userId = this.$store.getters.userId
      console.log(item)
      // return
      const noTokenFlag = this.$store.getters.noTokenFlag
      let isThirdPartPlat, token
      if (noTokenFlag) {
        isThirdPartPlat = true
        token = null
      } else {
        isThirdPartPlat = !isMideaConnect()
        token = this.token
      }

      if (!item.hasClicked) {
        // 点赞
        this.$store.dispatch('addLikeMxpOther', { isThirdPartPlat: isThirdPartPlat, articleId: typeStr === 'comment' ? item.id : this.articleId, targetType: typeStr, ssoToken: token, userId: userId, userName: userId })
          .then(success => {
            if (success && success.data && success.data.code === 0) {
              item.hasClicked = true
              item.likedNum = item.likedNum + 1
            } else {
              if (success.data.code === -1) {
                this.$toastMessage({ icon: '&#xe7a3;', message1: success.data.msg })
                // success.data.msg
              }
              // _self.success = false;
              // _self.popTxt = success.data.msg;
              // _self.showMask = true;
              // setTimeout(function() {
              //   _self.showMask = false;
              // }, 3000);
            }
          })
      } else {
        // 取消点赞
        this.$store.dispatch('cancelLikeMxpOther', { isThirdPartPlat: isThirdPartPlat, articleId: typeStr === 'comment' ? item.id : this.articleId, targetType: typeStr, ssoToken: token, userId: userId, userName: userId })
          .then(success => {
            if (success && success.data && success.data.code === 0) {
              item.hasClicked = false
              if (item.likedNum > 0) {
                item.likedNum = item.likedNum - 1
              }
            } else {
            // _self.success = false;
            // _self.popTxt = success.data.msg;
            // _self.showMask = true;
            // setTimeout(function() {
            //   _self.showMask = false;
            // }, 3000);
            }
          })
      }
    },
    validateParams () {
      // 查看文章。只有浏览器含有mideaconnect标识才可以实名评论。否则通通当游客身份处理。
      console.log(this.$route.params.id)
      if (this.$route.params.id) {
        // 消息标签跳转过来的文章
        this.$store.dispatch('setArticle', { article: {} })
        this.articleId = this.$route.params.id
      } else {
        this.articleId = this.$route.query.id
      }
      this.base_appkey = this.$route.query.base_appkey
      this.sid = this.$route.query.sid
      this.token = sessionStorage.getItem('token') || this.$route.query.token || null
      this.username = sessionStorage.getItem('username') || this.$route.query.username
      this.$store.dispatch('setUserId', { userId: this.username })
      this.$store.dispatch('setToken', { token: this.token })
      if (typeof this.sid === 'undefined' && typeof this.base_appkey === 'undefined') {
        // this.$toastMessage({ icon: '&#xe69f;', message1: `sid、base_appKey${this.$t('lang.notExist')}` })
        // this.errorStatus = true
        // return false
        this.sid = '237'
        this.base_appkey = sessionStorage.getItem('appkey') || '94624bb4,58031799-ea11-4bb7-b3db-68a9b438766c'
      }
      if (typeof this.sid === 'undefined') {
        // this.$toastMessage({ icon: '&#xe69f;', message1: `sid${this.$t('lang.notExist')}` })
        // this.errorStatus = true
        // return false
        this.sid = '237'
      }
      if (typeof this.base_appkey === 'undefined') {
        // this.$toastMessage({ icon: '&#xe69f;', message1: `base_appKey${this.$t('lang.notExist')}` })
        // this.errorStatus = true
        // return false
        this.base_appkey = sessionStorage.getItem('appkey') || '94624bb4,58031799-ea11-4bb7-b3db-68a9b438766c'
      }
      return true
    },
    handleCommentData (data) {
      if (data && data.data && data.data.code === 0) {
        if (data.data.data && data.data.data.list && data.data.data.list.length) {
          this.commentNum = data.data.data.total
          this.$store.dispatch('setCommentNum', {
            commentNum: this.commentNum
          })
          data.data.data.list.forEach((item) => {
            if (item.content) {
              item.content = item.content.replace(/%26/g, '&')
              // console.log(item.content);
            }
          })
          // this.appCommentList =
          data.data.data.list.forEach(item => {
            item.contentTooLong = item.content.length > 92
            if (item.subReplayList.length > 0) {
              item.subReplayList.forEach((ite, index) => {
                ite.contentTooLong = ite.content.length > 72
                ite.hidden = index >= 3
              })
            }
          })
          if (this.isRefresh) {
            this.appCommentList = []
          }
          if (this.pageNum === 1) {
            this.appCommentList = data.data.data.list
          } else {
            this.appCommentList = this.appCommentList.concat(data.data.data.list)
          }
        }
      }
      if (this.isRefresh) {
        this.isRefresh = false
      }
    },
    getCommentDetail (pageNum = 1) {
      const noTokenFlag = this.$store.getters.noTokenFlag
      let isThirdPartPlat, token
      if (noTokenFlag) {
        isThirdPartPlat = true
        token = null
      } else {
        isThirdPartPlat = !isMideaConnect()
        if (!this.token) {
          this.token = sessionStorage.getItem('token') || ''
        }
        token = this.token
      }
      this.$store.dispatch('queryCommentListMxp', { isThirdPartPlat: isThirdPartPlat, articleId: this.articleId, pageNum: pageNum, targetType: '1', ssoToken: token, userId: this.username })
        .then(res => {
          console.log(res)
          this.handleCommentData(res)
        })
    },
    getArticleDetail () {
      const noTokenFlag = this.$store.getters.noTokenFlag
      let isThirdPartPlat, token
      if (noTokenFlag) {
        isThirdPartPlat = true
        token = null
      } else {
        isThirdPartPlat = !isMideaConnect()
        if (!this.token || this.token === '$mam_token') {
          this.token = sessionStorage.getItem('token') || ''
        }
        if (!this.username || this.username === '$username') {
          this.username = sessionStorage.getItem('username') || ''
        }
        token = this.token
      }
      this.$store.dispatch('getArticleDetailMXP', { articleId: this.articleId, isThirdPartPlat: isThirdPartPlat, appKey: this.base_appkey, sid: this.sid, ssoToken: token, userId: this.username, username: this.username })
        .then(data => {
          // console.log(data)
          // this.handleArticleData(data)
          this.handleArticleData(data)
          this.weixinShare()
        })
    },
    loadComment () {
      this.loadMoreComment()
    },
    loadMoreComment: Throttle(function () {
      if (Math.ceil(this.$store.getters.commentNumber / 10) > this.pageNum) {
        ++this.pageNum
        this.getCommentDetail(this.pageNum)
      }
    })
  },
  created () {
    this.commentHeadImgUrl = this.$store.getters.headImgUrl
    if (this.isMideaConnect) {
      if (!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', getCookieOfToken('token'))
      }
      if (!sessionStorage.getItem('appkey')) {
        sessionStorage.setItem('appkey', getCookie('appkey'))
      }
      if (!sessionStorage.getItem('username')) {
        sessionStorage.setItem('username', getCookie('username'))
      }
    }
    if (window.location.href.indexOf('type=h5') > -1 && isPC()) {
      this.$store.dispatch('setNoTokenFlag', { noTokenFlag: true })
    }
    if (this.validateParams()) {
      // 挂载到vue原型上面，这样就可以在项目中调用了
      const result = {
        data: {
          /* global CONFIG */
          baseUrl: CONFIG.baseUrl
        }
      }

      Vue.prototype.$baseUrl = result.data.baseUrl
      if (this.$route.query.username) {
        this.headImgUrl = result.data.baseUrl + this.$store.getters.headImgUrl + this.$route.query.username
      }
      // 先看sessionStorage有无存储有文章，有则使用存储的，没有才去请求后台拿文章数据。
      // console.log(sessionStorage.getItem('article'))
      // const article = sessionStorage.getItem('article')
      const article = this.$store.getters.article
      if (typeof article.content !== 'undefined') {
        console.log(article)
        this.parseArticleData(article)
      } else {
        if (!this.$route.params.id) {
          this.getArticleDetail()
        }
      }
      this.getCommentDetail()
      this.hasLoadComment = true
    }
  },
  activated () {
    console.log('activated')
    if (this.$store.getters.articleTitle) {
      document.title = this.$store.getters.articleTitle
    }
    // console.log('??????')
    // this.appCommentList = []
    this.pageNum = 1

    const result = {
      data: {
        baseUrl: CONFIG.baseUrl
      }
    }
    Vue.prototype.$baseUrl = result.data.baseUrl
    if (this.$route.params.id) {
      // $('#content').html('')
      this.validateParams()
      this.getArticleDetail()
    }
    if (!this.hasLoadComment) {
      this.getCommentDetail()
      this.hasLoadComment = true
    }
    // document.querySelector('body').addEventListener('touchmove', function(e) {
    //   // 禁止底部拖动
    //   if (document.querySelector('.lite-page-editor').contains(e.target)) {
    //     e.preventDefault()
    //   }
    // })
  }
}
</script>
